(function(){
'use strict';

function scComment() {
  return {
    replace: true,
    scope: {
      commentable: '=scComment'
    },
    templateUrl: 'global/directives/interaction/scComment/template',
    link: function link() {}
  };
}

angular.module('classy').directive('scComment', scComment);
})();